// /src/components/Home.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// import axios from "axios";
// import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { createClientEnquiry } from "../api/auth/ClientEnquiry";
import {
  getTestimonials,
  getPlans,
  getPortfolio,
  getBlogs,


} from "../api/auth/authService";
import { getPlanDetails } from '../api/auth/planService';
import { getTeamMembers } from '../api/auth/teamService';
import { getClientLogo } from "../api/auth/ClientLogoService";
function Home() {
  const [logos, setLogos] = useState([]);

  const [testimonials, setTestimonials] = useState([]);
  const [planType, setPlanType] = useState([]);
  const [setPlan] = useState([]);
  const [data, setMemberData] = useState([]);
  const [portfolioData, setPortfolioData] = useState([]);
  const [blogs, setBlogs] = useState([]);
  // const colors = ["#6bc71a", "#b20d0d", "#38bec5", "#cfcc23", "#de7d0e"];
  const iconMap = {
    "OPD Management Solution for Clinic / Hospital": "icofont-hospital",
    "Pathology Management Solution": "icofont-laboratory",
    "Pharmacy Billing Solution": "icofont-pills",


  };

  const navigate = useNavigate();
  useEffect(() => {
    const fetchLogos = async () => {
      try {
        const data = await getClientLogo();
        setLogos(data);
      } catch (error) {
        console.error("Error fetching logo:", error);
      }
    };
    fetchLogos();
  }, []);



  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const data = await getTestimonials();
        setTestimonials(data);
      } catch (error) {
        console.error("Error fetching testimonials:", error.message);
      }
    };
    fetchTestimonials();
  }, []);

  useEffect(() => {
    const fetchPlanDetails = async () => {
      try {
        const data = await getPlanDetails();
        setPlanType(data);
      } catch (error) {
        console.error("Error fetching plan details:", error.message);
      }
    };
    fetchPlanDetails();
  }, []);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const data = await getPlans();
        setPlan(data);
      } catch (error) {
        console.error("Error fetching plans:", error.message);
      }
    };
    fetchPlans();
  }, [setPlan]);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const data = await getTeamMembers();
        setMemberData(data);
      } catch (error) {
        console.error("Error fetching team members:", error.message);
      }
    };
    fetchTeamMembers();
  }, []);

  useEffect(() => {
    const fetchPortfolio = async () => {
      try {
        const data = await getPortfolio();
        setPortfolioData(data);
      } catch (error) {
        console.error("Error fetching portfolio:", error.message);
      }
    };
    fetchPortfolio();
  }, []);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const data = await getBlogs();
        setBlogs(data);
      } catch (error) {
        console.error("Error fetching blogs:", error.message);
      }
    };
    fetchBlogs();
  }, []);

  const handleBookNow = (plan) => {
    navigate("/Booknow", { state: { plan } });
  };

  const [values, setValues] = React.useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
    date: ""
  });

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const currentDate = new Date().toISOString().split("T")[0];

    const payload = {
      ...values,
      date: currentDate
    };

    try {
      const response = await createClientEnquiry(payload);
      console.log(response.data);
      alert("Message sent successfully!");
      setValues({
        name: "",
        email: "",
        mobile: "",
        message: "",
        date: ""
      });
    } catch (error) {
      console.error("There was an error sending the message!", error);
      alert("Message not sent");
    }
  };

  return (
    <div>
      {/* <section className="schedule">

        <div className="container">
          <div className="schedule-inner">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12 ">
                <div className="single-schedule first">
                  <div className="inner">
                    <div className="icon">
                      <i className="fa fa-ambulance"></i>
                    </div>
                    <div className="single-content">
                      <span>Lorem Amet</span>
                      <h4>Emergency Cases</h4>
                      <p>
                        Lorem ipsum sit amet consectetur adipiscing elit. Vivamus
                        et erat in lacus convallis sodales.
                      </p>
                      <a href="#">
                        LEARN MORE<i className="fa fa-long-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="single-schedule middle">
                  <div className="inner">
                    <div className="icon">
                      <i className="icofont-prescription"></i>
                    </div>
                    <div className="single-content">
                      <span>Fusce Porttitor</span>
                      <h4>Doctors Timetable</h4>
                      <p>
                        Lorem ipsum sit amet consectetur adipiscing elit. Vivamus
                        et erat in lacus convallis sodales.
                      </p>
                      <a href="#">
                        LEARN MORE<i className="fa fa-long-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-12">
                <div className="single-schedule last">
                  <div className="inner">
                    <div className="icon">
                      <i className="icofont-ui-clock"></i>
                    </div>
                    <div className="single-content">
                      <h4>Opening Hours</h4>
                      <ul className="time-sidual">
                        <li className="day">
                          Monday - Fridayp <span>8.00-20.00</span>
                        </li>
                        <li className="day">
                          Saturday <span>9.00-18.30</span>
                        </li>
                        <li className="day">
                          Monday - Thusday <span>9.00-15.00</span>
                        </li>
                      </ul>
                      <a href="#">
                        LEARN MORE<i className="fa fa-long-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section> */}

      <section className="why-choose section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">

                <h3>We Offer IT Healthcare Services to Improve Your Business </h3>
                <img src="img/section-img.png" alt="#" />
                <p>
                  At Webnet Technologies, we specialize in providing innovative IT healthcare services designed to enhance the efficiency, reliability, and growth of your business. Our solutions help healthcare providers streamline operations, ensure secure data management, and deliver better patient care.

                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="choose-left">
                <h3>Who We Are</h3>
                <p>

                  At WebNet Care, we believe in the power of technology to transform businesses, simplify operations, and improve lives. Founded with a vision to deliver intelligent, user-friendly, and reliable software solutions, we are a team of passionate professionals driven by innovation and purpose.
                </p>
                {/* <p>
                  We specialize in building custom web and mobile applications that help businesses automate workflows, streamline management, and scale effectively. With a client-first approach and a strong focus on quality, our solutions are designed to meet the unique needs of every customer — whether you're a startup, hospital, educational institution, or enterprise.
                </p> */}
                <div className="row">
                  <div className="col-lg-12">
                    <ul className="list">
                      <li>
                        <i className="fa fa-caret-right"></i>Customer-Centric:-We listen, understand, and build solutions that solve real problems.

                      </li>
                      <li>
                        <i className="fa fa-caret-right"></i>Integrity:-We believe in transparency, honesty, and long-term relationships. </li>
                      <li>
                        <i className="fa fa-caret-right"></i>Innovation:-We constantly adapt, learn, and evolve to stay ahead of the curve.
                      </li>
                      <li>
                        <i className="fa fa-caret-right"></i>QualityL-We deliver nothing but the best, every single time.
                      </li>
                    </ul>
                  </div>
                  {/* <div className="col-lg-6">
                    <ul className="list">

                      <li>

                        <i className="fa fa-caret-right"></i>Duis massa massa.
                      </li>
                      <li>
                        <i className="fa fa-caret-right"></i>Aliquam feugiat
                        interdum.
                      </li>
                    </ul>

                  </div> */}

                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="choose-right">

                {/* <img src="img/video-bg.jpg" alt="#"  className="img-fluid"/> */}
                {/* <div className="video-image">

                  <div className="promo-video">
                    <div className="waves-block">
                      <div className="waves wave-1"></div>
                      <div className="waves wave-2"></div>
                      <div className="waves wave-3"></div>
                    </div>
                  </div>
                  <a
                    href="https://www.youtube.com/watch?v=RFVXy6CRVR4"
                    className="video video-popup mfp-iframe"
                    rel="noreferrer"
                  >
                    <i className="fa fa-play"></i>
                  </a>

                </div> */}

              </div>
            </div>
          </div>
        </div>
      </section>

      <div id="fun-facts" className="fun-facts section overlay">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-fun">
                <i className="icofont-simple-smile"></i>
                <div className="content">
                  <span className="counter">1000</span>
                  <p>Happy Clients</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-fun">
                <i className="icofont icofont-table"></i>
                <div className="content">
                  <span className="counter">15</span>
                  <p>Years of Experience</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="Feautes section mt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h3>We Are Always Ready to Help You </h3>
                <img src="img/section-img.png" alt="#" />
                <p>
                  At Webnet Technologies, we believe healthcare should be simple, digital, and patient-friendly. Our IT healthcare solutions are designed to support hospitals, clinics, and doctors with smart tools for appointments, billing, medical records, and telemedicine.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-12">
              <div className="single-features">
                <div className="signle-icon">
                  <i className="fa-solid fa-chart-simple"></i>
                </div>
                <h3>Analysis</h3>
                <p>
                  At Webnet Technologies, we deliver advanced healthcare data analysis solutions that convert raw data into actionable insights, empowering hospitals and clinics to make smarter decisions
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="single-features">
                <div className="signle-icon">
                  <i className="fa-solid fa-compass-drafting"></i>
                </div>
                <h3>Design</h3>
                <p>
                  At Webnet Technologies, we believe every solution starts with a smart design. Our healthcare systems are carefully designed to be user-friendly, secure, and scalable, ensuring smooth experiences for doctors, staff, and patients.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="single-features last">
                <div className="signle-icon">
                  <i className="fa-regular fa-truck"></i>
                </div>
                <h3> Deliver</h3>
                <p>
                  Delivering value is at the heart of Webnet Technologies. We ensure that every healthcare IT solution we provide is delivered with precision, reliability, and speed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section
        className="call-action overlay"
        data-stellar-background-ratio="0.5"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="content">

                <h2>Do you need our support? Call at <br></br> +91 805 131 6666</h2>
                <p>
                  Have questions, need support, or want to learn more about our services? Our team at WebNet Care is always ready to assist you. Reach out to us anytime through the channels below.

                </p>
                <div className="button">
                  <a href="/contactus" className="btn btn-primary">
                    Contact Now
                  </a>

                  {/* <a href="#" className="btn second">
                    Learn More<i className="fa fa-long-arrow-right"></i>
                  </a> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="portfolio section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">

              <div className="section-title text-center">

                <h2>Smart Healthcare IT Solutions</h2>
                <img src="img/section-img.png" alt="#" />
                <p>
                  We provide advanced healthcare IT solutions designed to improve patient care, streamline hospital operations, and enhance data security. Our smart systems include electronic health records, telemedicine platforms, hospital management software, and secure digital networks—helping healthcare providers deliver faster, safer, and more efficient services.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row g-3 justify-content-center">
            {portfolioData.length > 0 ? (
              portfolioData.slice(0, 5).map((item) => (
                <div
                  className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center"
                  key={item.id}
                >
                  <img
                    src={
                      item.imageBytes
                        ? `data:image/jpeg;base64,${item.imageBytes}`
                        : "https://via.placeholder.com/150"
                    }
                    alt={item.name}
                    className="img-fluid rounded"
                  />
                  {/* <p className="clintname mt-2">{item.name}</p> */}
                </div>
              ))
            ) : (
              <p>No portfolio items found.</p>
            )}
          </div>
        </div>
      </section>

      <section className="services ">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center">
                <h2>We Offer Different Services To Improve Your Health</h2>
                <img src="img/section-img.png" alt="Section Icon" />
                <p>
                  At our healthcare center, we believe in providing complete care that goes beyond just treatment.
                  Our goal is to help you achieve and maintain a healthier lifestyle with services designed to
                  meet your unique needs. Whether you need preventive care, specialist consultations, or wellness
                  support, we are here for you.

                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-service text-center">
                <img src="Icon/OPD.png" alt="Hospital Icon" className="service-icon" />
                <h4>OPD & IPD</h4>
                <p>
                  Our OPD management solution streamlines outpatient care with features like online booking, patient registration, doctor scheduling, billing, and medical history tracking, ensuring fast and patient-friendly service.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-service text-center">
                <img src="Icon/prescription.png" alt="Doctor Prescription" className="service-icon" />
                <h4>Doctor Prescription</h4>
                <p>
                  Our Doctor Prescription module enables healthcare providers to create, manage, and share
                  prescriptions digitally. It eliminates paper-based errors, improves accuracy, and ensures
                  that patients receive the right treatment at the right time.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-service text-center">
                <img src="Icon/PATHOLOGY.png" alt="Pathology & Radiology" className="service-icon" />
                <h4>Pathology & Radiology</h4>
                <p>
                  Our Pathology & Radiology modules ensure accurate diagnostic support with seamless integration
                  into the hospital management system. From lab tests to imaging reports, everything is digitized,
                  tracked, and securely stored for quick access.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-service text-center">
                <img src="Icon/pharmacy.png" alt="Pharmacy Management" className="service-icon" />
                <h4>Pharmacy Management</h4>
                <p>
                  Our Pharmacy Management System simplifies medicine dispensing, stock control, and billing,
                  ensuring accuracy, transparency, and efficiency in pharmaceutical operations.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-service text-center">
                <img src="Icon/public-relation.png" alt="Client Management" className="service-icon" />
                <h4>Client Management</h4>
                <p>
                  Our Client  Management System helps healthcare organizations manage partners, suppliers, and service providers with ease, ensuring transparency and compliance.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-service text-center">
                <img src="Icon/inventory.png" alt="Inventory Management" className="service-icon" />
                <h4>Inventory Management</h4>
                <p>
                  Our Inventory Management System ensures real-time tracking and control of all medical supplies,
                  consumables, and assets within the healthcare facility.

                </p>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className="pricing-table section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">

                <h2>We Provide You The Best Solution In Reasonable Price</h2>

                <img src="img/section-img.png" alt="section-img" />
                <p>
                  We provide the best solutions at affordable and reasonable prices.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {planType.slice(0, 3).map((item, index) => (
              <div key={index} className="col-lg-4 col-md-12 col-12">
                <div className="single-table">
                  <div className="table-head">
                    <div className="icon">
                      <i
                        className={`icofont ${iconMap[item.plantype] || "icofont-stethoscope"
                          }`}

                      ></i>
                    </div>
                    <h4 className="title">{item.plantype}</h4>
                    <div className="price">
                      <p className="amount">

                        ₹{item.price}

                        {/* <span>/ GST 18%</span> */}
                      </p>
                    </div>
                  </div>
                  <ul className="table-list list-unstyled">
                    {item.feature &&
                      item.feature.split(",").map((f, i) => (
                        <li key={i} className="mb-2">
                          <i className="fa fa-check"></i>
                          {f.trim()}
                        </li>
                      ))}
                    <hr style={{ border: '1px solid #1279d9ff', margin: '10px 0' }}></hr>
                    {/* Details as last line */}
                    <li className="mt-2">
                      {/* <i className="fa fa-check"></i> */}
                      {item.details}
                    </li>
                  </ul>



                  <div className="table-bottom">
                    <button
                      className="btn"
                      onClick={() => handleBookNow(item)}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="blog mt-5" id="blog">

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>Keep up with Our Most Recent Medical News.</h2>
                <img src="img/section-img.png" alt="#" />
                {/* <p>
                  Lorem ipsum dolor sit amet consectetur adipiscing elit praesent
                  aliquet. pretiumts
                </p> */}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="row">
              {blogs.length > 0 ? (
                blogs
                  .sort((a, b) => new Date(b.date) - new Date(a.date))
                  .slice(0, 3)
                  .map((item) => (
                    <div className="col-lg-4 col-md-6 col-12" key={item.id}>
                      <div className="single-news">
                        <div className="news-head">
                          <img
                            src={
                              item.imageBytes
                                ? `data:image/jpeg;base64,${item.imageBytes}`
                                : "https://via.placeholder.com/100"
                            }
                            alt={item.title}
                            style={{
                              height: "250px",
                              width: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <div className="news-body">
                          <div className="news-content">
                            <div className="date">
                              {new Date(item.date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })}
                            </div>
                            <h2>
                              <a href="/Blogs">{item.title}</a>
                            </h2>
                            <p
                              className="text"
                              dangerouslySetInnerHTML={{
                                __html: item.description.substring(0, 100) + "...",
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
              ) : (
                <p>No blogs found.</p>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="team section py-5" style={{ background: "#faf8f8" }}>
        <div className="container">

          <div className="section-title text-center mb-4" >
            <h2 style={{ color: "#333" }}>Meet Our Team</h2>
            <img src="img/section-img.png" alt="section-img" />
            <p style={{ color: "#333" }}>
              Behind our success is a team of highly skilled professionals who combine technology expertise with deep healthcare domain knowledge. Our team works collaboratively to deliver secure, innovative, and cost-effective IT solutions that empower hospitals, clinics, laboratories, and healthcare organizations.
            </p>
          </div>

          <div className="row">
            {data.slice(0, 5).map((member, index) => (
              <div
                key={member.id}
                className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4"
              >
                <div
                  className="card text-center shadow-sm h-100"
                  style={{
                    background: "#ffffff", borderLeft: "3px solid #728af2",
                    borderRadius: "12px",
                    padding: "20px"
                  }}
                >

                  <div className="mb-3">
                    <img
                      className="team-member-image"
                      src={
                        member.imageBytes
                          ? `data:image/jpeg;base64,${member.imageBytes}`
                          : "https://via.placeholder.com/100"
                      }
                      alt={member.name}
                      style={{
                        width: "180px",
                        height: "180px",
                        borderRadius: "50%",
                      }}
                    />
                  </div>

                  <p className="mb-1 fw-bold" style={{ fontSize: "1.1rem", color: "#333" }}>
                    {member.name}
                  </p>

                  <p className="mb-0" style={{ color: "#555", fontSize: "0.9rem" }}>
                    {member.designation}
                  </p>

                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      <div className="clients overlay py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="logos-scroll">
                <div className="logos-track">
                  {[...logos, ...logos].map((logo, index) => (
                    <div className="single-client" key={index}>
                      <img
                        src={
                          logo.imageBytes
                            ? `data:image/jpeg;base64,${logo.imageBytes}`
                            : "https://via.placeholder.com/150"
                        }
                        alt={logo.name}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <style>{`
    .logos-scroll {
      overflow: hidden;
      position: relative;
      width: 100%;
    }

    .logos-track {
      display: flex;
      gap: 30px;
      width: max-content;
      animation: scrollLogos 20s linear infinite;
    }

    .single-client {
      flex: 0 0 auto;
      width: 150px;
    }

    .single-client img {
      width: 100%;
      border-radius: 10px;
      transition: transform 0.3s;
    }

    .single-client img:hover {
      transform: scale(1.1);
    }

    @keyframes scrollLogos {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-50%);
      }
    }

    /* Responsive */
    @media (max-width: 768px) {
      .single-client {
        width: 100px;
      }
    }
  `}</style>
      </div>

      <div className="container-fluid px-2 px-md-4 py-5 mx-auto">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title">
              <h2>What our clients are saying about us.</h2>
              <img src="img/section-img.png" alt="#" />
            </div>
          </div>
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-md-10 col-lg-9 col-xl-8">
            <div
              id="carouselExampleIndicators"
              className="carousel slide"
              data-bs-ride="carousel"
              data-bs-interval="3000"
            >
              <div className="carousel-indicators">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={index}
                    className={index === 0 ? "active" : ""}
                    aria-current={index === 0 ? "true" : "false"}
                    aria-label={`Slide ${index + 1}`}
                  ></button>
                ))}
              </div>
              <div className="carousel-inner">
                {testimonials.map((item, index) => (
                  <div
                    key={item.id}
                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                  >
                    <div
                      className="card border-0 card-0 testimonial"
                      style={{ border: "2px solid red", background: "#3D90D7" }}
                    >
                      <div className="card profile py-3 px-4">
                        <div className="text-center">
                          <img
                            src={
                              item.imageBytes
                                ? `data:image/jpeg;base64,${item.imageBytes}`
                                : "https://via.placeholder.com/100"
                            }
                            alt={item.name}
                            className="img-fluid profile-pic"
                          />
                        </div>
                        <h6 className="mb-0 mt-2" style={{ textAlign: 'center' }}>{item.name}</h6>
                        <small style={{ textAlign: 'center' }}>{item.designation}</small>
                      </div>
                      <img
                        className="img-fluid open-quotes"
                        src="https://i.imgur.com/Hp91vdT.png"
                        width="20"
                        height="20"
                        alt="quote"
                      />
                      <p className="cont mb-0">{item.description}</p>
                      <img
                        className="img-fluid close-quotes ml-auto"
                        src="https://i.imgur.com/iPcHyJK.png"
                        width="20"
                        height="20"
                        alt="quote"
                      />
                    </div>
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <section className="newsletter section">
        <div className="container">
          <div className="row justify-content-center">
            {/* Heading Section */}
            <div className="col-lg-8 col-md-10 text-center">
              <div className="subscribe-text">
                <h6 style={{ fontWeight: "bold" }}>Send us an Enquiry</h6>
                <p style={{ fontWeight: "600" }}>
                  Please fill out the form below and we'll get back to you shortly.
                </p>
              </div>
            </div>

            {/* Form Section */}
            <div className="col-lg-7 col-md-10 pt-4">
              <div className="subscribe-form">
                <form onSubmit={handleSubmit}>
                  {/* Name and Mobile in One Row */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <input
                        name="name"
                        type="text"
                        placeholder="Your Name"
                        className="common-input form-control"
                        onChange={handleChanges}
                        value={values.name}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <input
                        name="mobile"
                        type="text"
                        placeholder="Your Mobile Number"
                        className="common-input form-control"
                        onChange={handleChanges}
                        value={values.mobile}
                        required
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="mb-3">
                    <input
                      name="email"
                      type="email"
                      placeholder="Your email address"
                      className="common-input form-control w-100"
                      onChange={handleChanges}
                      value={values.email}
                      required
                    />
                  </div>

                  {/* Message */}
                  <div className="mb-3">
                    <textarea
                      name="message"
                      placeholder="Your Message"
                      className="common-input form-control w-100"
                      onChange={handleChanges}
                      value={values.message}
                      rows="4"
                      required
                    />
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="btn btn-primary text-uppercase m-0 w-100"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>



    </div>
  );
}

export default Home;